import React from 'react'
import { connect } from 'react-redux'
import Autocomplete from '../components/Autocomplete'
import { makeGetData } from '../selectors/dataSelector'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import MapActions from '../redux/mapRedux'

const wellsites = [
  {
    "well_name": "PCP ET AL COUNTESS 10-3-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2680.416458852868,
    "ndviControlAverage": 2626.378962536023,
    "ndviBufferAverage": 2533.163043478261,
    "ratio": 1.020574904493092,
    "latitude": 50.494269349686434,
    "longitude": -111.98392834306942,
    "uuid": "301488c7-4b3b-42ec-9613-8fb4f9684cfb"
  },
  {
    "well_name": "PCP COUNTESS 9-4-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2803.8117913832198,
    "ndviControlAverage": 2639.122507122507,
    "ndviBufferAverage": 2721.1195652173915,
    "ratio": 1.062403046397523,
    "latitude": 50.493959324992666,
    "longitude": -112.00322995010356,
    "uuid": "92ed5d6a-4de4-4df4-af49-4e3d8fbb4705"
  },
  {
    "well_name": "PCP COUNTESS 2-2-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2373.9200968523,
    "ndviControlAverage": 2405.5265625,
    "ndviBufferAverage": 2435.044776119403,
    "ratio": 0.9868608951817801,
    "latitude": 50.488277006280484,
    "longitude": -111.96254536920272,
    "uuid": "88a6d8b5-9ee5-4148-b3b6-40825e9497ff"
  },
  {
    "well_name": "OAK ET AL COUNTESS 3-2-18-16",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "Canadian Natural Resources Limited",
    "ndviLeaseAverage": 2544.995133819951,
    "ndviControlAverage": 2520.378260869565,
    "ndviBufferAverage": 2463.1444444444446,
    "ratio": 1.0097671342959025,
    "latitude": 50.48734681480194,
    "longitude": -112.10216226616949,
    "uuid": "52ad3bd6-4e20-4fc9-83c7-4d4356415a76"
  },
  {
    "well_name": "MANA CPOG ET AL NEWELL 10-4-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "Mana Resources Inc",
    "ndviLeaseAverage": 2769.478873239437,
    "ndviControlAverage": 2690.7562408223203,
    "ndviBufferAverage": 2718.943181818182,
    "ratio": 1.0292566941675318,
    "latitude": 50.49393084267794,
    "longitude": -112.00650743947584,
    "uuid": "e83dc891-dd5b-4643-a51c-b29154d6c1a4"
  },
  {
    "well_name": "MANA CPOG ET AL COUNT 11-3-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2629.5577689243028,
    "ndviControlAverage": 2615.0564635958394,
    "ndviBufferAverage": 2643.8720930232557,
    "ratio": 1.0055453125124967,
    "latitude": 50.49414326135721,
    "longitude": -111.98959302643846,
    "uuid": "4ad68d3a-e91d-40e1-a088-770a0e705f35"
  },
  {
    "well_name": "PCP BONANZA COUNTESS 10-5-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2634.1392405063293,
    "ndviControlAverage": 2625.4110787172012,
    "ndviBufferAverage": 2626.4,
    "ratio": 1.0033244933945327,
    "latitude": 50.49364434317829,
    "longitude": -112.02898879923072,
    "uuid": "8b54a14d-3886-4c92-9f6d-2c31dd1844ff"
  },
  {
    "well_name": "MANA CPOG ET AL NEWELL 10-1-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2918.04802259887,
    "ndviControlAverage": 2992.2282828282828,
    "ndviBufferAverage": 3270.41975308642,
    "ratio": 0.9752090237716432,
    "latitude": 50.49392141350855,
    "longitude": -111.93763480151895,
    "uuid": "863ed31d-6834-421c-9fb3-4d4f6b485a0d"
  },
  {
    "well_name": "PCP BONANZA COUNTESS 6-5-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2493.9600997506236,
    "ndviControlAverage": 2447.0153139356817,
    "ndviBufferAverage": 2397.7727272727275,
    "ratio": 1.0191845083876643,
    "latitude": 50.490949780496955,
    "longitude": -112.03619038432032,
    "uuid": "e00cfbc2-272d-4005-ab68-44b6302ea3bb"
  },
  {
    "well_name": "PCP ET AL COUNTESS 6-3-18-15",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2448.820253164557,
    "ndviControlAverage": 2515.646376811594,
    "ndviBufferAverage": 2503.0666666666666,
    "ratio": 0.9734358039098744,
    "latitude": 50.49165121695131,
    "longitude": -111.99132824704103,
    "uuid": "169c6cdc-78eb-4693-8e55-7c2a29cf4606"
  },
  {
    "well_name": "Demo 1",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2448.820253164557,
    "ndviControlAverage": 2515.646376811594,
    "ndviBufferAverage": 2503.0666666666666,
    "ratio": 0.9734358039098744,
    "latitude": 50.5468,
    "longitude": -112.0983,
    "uuid": "169c6cdc-78eb-4693-8e55-7c2a29cf4606"
  },
  {
    "well_name": "Demo 2",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2448.820253164557,
    "ndviControlAverage": 2515.646376811594,
    "ndviBufferAverage": 2503.0666666666666,
    "ratio": 0.9734358039098744,
    "latitude": 50.5433,
    "longitude": -112.0762,
    "uuid": "169c6cdc-78eb-4693-8e55-7c2a29cf4606"
  },
  {
    "well_name": "Demo 3",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2448.820253164557,
    "ndviControlAverage": 2515.646376811594,
    "ndviBufferAverage": 2503.0666666666666,
    "ratio": 0.9734358039098744,
    "latitude": 50.553,
    "longitude": -112.0358,
    "uuid": "169c6cdc-78eb-4693-8e55-7c2a29cf4606"
  },
  {
    "well_name": "Demo water",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2448.820253164557,
    "ndviControlAverage": 2515.646376811594,
    "ndviBufferAverage": 2503.0666666666666,
    "ratio": 0.9734358039098744,
    "latitude": 50.5517,
    "longitude": -111.8687,
    "uuid": "169c6cdc-78eb-4693-8e55-7c2a29cf4606"
  },
  {
    "well_name": "Demo vegetation V",
    "timestamp": "2013-07-14T00:00:00.228Z",
    "licensee": "EnCana Corporation",
    "ndviLeaseAverage": 2448.820253164557,
    "ndviControlAverage": 2515.646376811594,
    "ndviBufferAverage": 2503.0666666666666,
    "ratio": 0.9734358039098744,
    "latitude": 50.5523,
    "longitude": -111.8454,
    "uuid": "169c6cdc-78eb-4693-8e55-7c2a29cf4606"
  }
]

const AutocompleteContainer = ({ suggestions, actions, onClick = (center, zoom) => console.log(center, zoom) }) => {
  // console.log('suggestions', suggestions)
  // if (!suggestions) {
  //   return null
  // }
  return (
    <Autocomplete suggestions={wellsites} labelKey='well_name' onClick={actions.centerZoomChanged} />
  )
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getData = makeGetData()

  const mapStateToProps = (state, ownProps) => {
    return {
      suggestions: getData(
        state,
        'Mopra',
        getFeaturesFromGeoJson,
        datum => datum.timestamp === getDatetime(state, 'Mopra')
      )
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      centerZoomChanged: (center, zoom) => {
        dispatch(MapActions.centerZoomChanged(center, zoom))
      }
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(AutocompleteContainer)



// WEBPACK FOOTER //
// ./src/containers/AutocompleteContainer.js